import fetch from './fetch'

class AreaApi {
	public getProvince() {
		return fetch({
			url: 'injury/resource/province',
		})
	}

	public getCity(parentCode: string) {
		return fetch({
			url: 'injury/resource/city',
			params: {
				parentCode,
			},
		})
	}

	public getArea(parentCode: string) {
		return fetch({
			url: 'injury/resource/area',
			params: {
				parentCode,
			},
		})
	}

	public searchArea(keywords: string) {
		return fetch({
			url: 'injury/resource/searchArea',
			params: {
				keywords,
			},
		})
	}

	public getAreaTree() {
		return fetch({
			url: 'injury/resource/areaLists',
		})
	}

	public hospitalTips(form: any) {
		return fetch({
			url: 'injury/resource/hospitalTips',
			method: 'post',
			data: form,
		})
	}
	public config(form: any) {
		return fetch({
			url: 'injury/resource/setting/config',
			method: 'post',
			data: form,
		})
	}
}

export default new AreaApi()
